import { Document, pdfjs, Page } from 'react-pdf';
import { useEffect, useState } from 'react';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.mjs`;

const getViewerWidth = () => {
	const width = window.innerWidth;

	if (width >= 1400) return 900;
	if (width >= 992) return width - 400;
	if (width >= 576) return width - 170;

	return width - 50;
};

export default function PDFViewer({ link }: { link: string }) {
	const [numPages, setNumPages] = useState(0);
	const [containerWidth, setContainerWidth] = useState<number>(getViewerWidth());
	
	useEffect(() => {
		const handleResize = () => {
			setContainerWidth(getViewerWidth());
		};

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	function onDocumentLoadSuccess({ numPages }: { numPages: number }) {
		setNumPages(numPages);
	}

	return (
		<div className="flex flex-col items-center">
			<Document file={link} onLoadSuccess={onDocumentLoadSuccess} className="pdfViewer">
				{Array.from(new Array(numPages), (el, index) => (
					<Page key={`page_${index + 1}`} pageNumber={index + 1} width={containerWidth} />
				))}
			</Document>
		</div>
	);
}
